import $ from "jquery";

function binarySearch(array, item, comparer) {
	var i, l;
	for(i = 0, l = array.length - 1; i <= l;) {
		var m = i + ((l - i) >> 1);
		var r = comparer(array[m], item);
		if(r === 0)
			return m;
		else if(r < 0)
			i = m + 1;
		else
			l = m - 1;
	}
	return ~i;
}

var optionsDataKey = "thead-scroll-options";
var headerClass = "fs-gridheader ui-sticky noprint";
var sectionClass = "fs-grouphead";
var scrollData = "fsScroll";

function THeadScroll(table, options) {
	var wrap = null, frow = null;
	table.data(optionsDataKey, options);

	function init() {
		var h = table.find(">caption,>thead");
		if(h.length) {
			frow = $(table[0].cloneNode(false));
			// perform some fixes jQuery.clone() does
			frow.attr($.expando, "");
			// ...
			frow.addClass("noprint")
			.css("table-layout", "fixed")
			.append(h.clone(true, true));
			h.css("visibility", "hidden");
			// at the moment "customize" and "filter" won't work with cloning
			$(".fs-customize,tr.fs-filterrow", frow).remove();
			// forward events from cloned header to original checkbox
			$("input[type=checkbox].fs-selectall", frow).on("click", function(e) {
				$("input[type=checkbox].fs-selectall", table[0].tHead)[0].click();
				e.stopPropagation();
			});
			syncSize();
			wrap = $("<div class=\"" + headerClass + "\"/>")
			.append($("<div>").append(frow))
			.data("scrolltable", table);
			table.parent().append(wrap);
		}
	}

	function dispose() {
		table.find(">caption,>thead").css("visibility", "");
		wrap.remove();
		wrap = frow = null;
	}

	function onresize() {
		syncSize();
		syncPos(
			$(window).scrollLeft(), $(window).scrollTop(),
			table.offset(), table.height());
	}

	function onscroll() {
		var b = table.offset();
		var h = table.height();
		var scX = $(window).scrollLeft() + options.left;
		var scY = $(window).scrollTop() + options.top;
		if(b.top < scY && b.top + h > scY) {
			if(wrap == null)
				init();
			syncPos(scX, scY, b, h);
		}
		else if(wrap != null) {
			dispose();
		}
	}

	function syncPos(scX, scY, b, h) {
		if(wrap == null) return;
		var css = {
			position: "fixed",
			left: b.left - scX,
			top: Math.max(b.top - scY, Math.min(b.top + h - wrap.outerHeight() - scY, 0) + options.top),
			zIndex: 1
		};
		if(window.isIOS) {
			var ofp = wrap[0].offsetParent;
			ofp = ofp != null ? $(ofp).offset() : { left: 0, top: 0 };
			css.position = "absolute";
			css.left += scX - ofp.left;
			css.top += scY - ofp.top;
			// why to sub options??????
			css.top -= options.top;
		}
		wrap.css(css);
		scrollGroups(scX, scY, b);
	}

	function syncSize() {
		if(frow == null) return;
		// sync table widths
		frow.width(table.width());
		// sync cell widths
		var tho = table[0].tHead.rows, thn = frow[0].tHead.rows;
		for(var i = 0, k = thn.length; i < k; i++) {
			var tro = tho[i].cells, trn = thn[i].cells;
			for(var j = 0, l = trn.length; j < l; j++)
				$(trn[j]).width($(tro[j]).width());
		}
	}

	function scrollGroups(scX, scY, b) {
		if(frow == null) return;

		var trows = table[0].rows;

		var n = binarySearch(trows, scY - b.top + frow[0].tHead.offsetHeight, function(r, y) {
			var rt = r.offsetTop;
			var rb = rt + r.offsetHeight;
			return (rb < y) ? -1 : (y < rt) ? 1 : 0;
		});
		var tsec = $();
		if(n < 0) n = ~n;
		if(n < trows.length)
			tsec = $(trows[n].parentNode);
		if(tsec.is("tbody:not(." + sectionClass + ")"))
			tsec = tsec.prev();
		if(tsec.is("tbody." + sectionClass)) {
			var fbodies = frow.children("tbody:first");
			var cloned = false;
			if(fbodies.length === 0) {
				cloned = true;
				tsec.data(scrollData, 1);
				frow.append(fbodies = tsec.clone());
			}
			else if(tsec.data(scrollData) != 1) {
				cloned = true;
				table.children("tbody").removeData(scrollData);
				tsec.data(scrollData, 1);
				fbodies = tsec.clone().replaceAll(fbodies);
			}
			if(cloned) {
				// forward events from cloned header to original checkbox
				$("input[type=checkbox].fs-selectgroup", fbodies).on("click", function(e) {
					$("input[type=checkbox].fs-selectgroup", tsec)[0].click();
					e.stopPropagation();
				});
			}
			$(fbodies[0].rows[0].cells[0])
				.css("paddingLeft", Math.max(scX - b.left, 0) + 7);
		}
	}

	$(window).scroll(onscroll).resize(onresize);
}

function ensureVisible2(elt) {
	elt = $(elt);
	if(!elt.length) return;
	var winTop = $(window).scrollTop();
	var newTop = winTop;
	var winBottom = winTop + $(window).innerHeight();
	var eltTop = elt.offset().top;
	var eltBottom = eltTop + elt.outerHeight();
	var dy = 0;
	// on or below the bottom edge of the window?
	if(eltBottom > winBottom) {
		// align bottom edges
		dy = winBottom - eltBottom;
	}

	// check if it is in grid
	var grid = elt.closest("table.fs-grid");
	if(grid.length) {
		var gridTop = grid.offset().top;
		var gridTopOffset = newTop + grid.data(optionsDataKey).top;
		if(gridTop < gridTopOffset) { // header will scroll
			grid.find(">caption,>thead,>tbody.fs-grouphead:first").each(function () {
				gridTopOffset += $(this).outerHeight();
			});
			newTop = gridTopOffset;
		}
	}
	// above the top edge?
	if(eltTop < newTop) {
		dy = newTop - eltTop;
	}
	window.scrollBy(0, dy);
}

/*
function ensureVisible(elt) {
	setTimeout(function() {
		var wrap = $("div." + headerClass.split(" ").join(".") + ":first");
		if(wrap.length) {
			var table = wrap.data("scrolltable");
			var m = $(elt, table);
			if(m.length) {
				var top = m.offset().top - $(window).scrollTop(), wh = wrap.outerHeight();
				var bottomExtra = top + m.outerHeight() - $(window).innerHeight();
				if(bottomExtra > 0) {
					top -= bottomExtra;
				}
				if(top < wh) { // obscured by caption 
					window.scrollBy(0, top - wh);
				} else if(bottomExtra > 0) {
					window.scrollBy(0, bottomExtra);
				}
			}
		}
	}, 100);
}
*/

$.ensureVisible = ensureVisible2;

$.fn.tHeadScroll = function(options) {
	// bail out, no fixed positioning support
	if(/MSIE [1-6]\b/i.test(navigator.userAgent))
		return;

	options = $.extend({ left: 0, top: 0 }, options);

	/// <summary>Scrolls table headers into view</summary>
	return this.each(function(i, e) {
		var th = e.tHead;
		if(th != null && th.rows.length > 0) {
		    // TODO: FF: https://bugzilla.mozilla.org/show_bug.cgi?id=975644
			// TODO: Edge: https://dev.modern.ie/platform/status/positionsticky
			// th.style.position = "-webkit-sticky";
			// th.style.position = "sticky";
			// th.style.top = options.top + "px";
			new THeadScroll($(e), options);
		}
	});
};
